import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formattedDate } from "./helper";
import {
  getPayoutCountsNetworkAction,
  getPayoutDetailsNetworkAction,
} from "../../../redux/actions/PayoutAction";
import { getNetworkMenuId } from "../../../Utils/types";
import { getSnackbarSuccess } from "../../../Utils/helper";

export const TotalPayout = ({
  setSwitchTab,
  searchFilter,
  setProviderDetail,
  setMonth,
  setSearchFilter,
  downloadFile,
  isLoadingExcel,
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  useEffect(() => {
    dispatch(getPayoutDetailsNetworkAction(searchFilter));
  }, []);

  return (
    <>
    <div className="table-responsive __custom__properties">
        
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th>Month</th>
              <th style={{textAlign:"center"}}>Appointment</th>
              <th style={{textAlign:"center"}}>Provider Amount</th>
              <th style={{textAlign:"center"}}>TDS</th>
              <th style={{textAlign:"center"}}>Net Amount</th>
              <th style={{textAlign:"center"}}>Status</th>
              <th style={{textAlign:"center"}}>Action</th>
              <th style={{textAlign:"center"}}>Export</th>
            </tr>
          </thead>
          {payoutReducer?.getPayoutDetailsList?.length !== 0 && <tbody>
            {payoutReducer?.getPayoutDetailsList?.map((ele, index) => {
              return (
                <tr>
                  <td>
                    <a
                      className="text-highlighted text-decoration"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSwitchTab("totalProviders");
                        setMonth(
                          new Date(
                            ele?.appointmentClosedDate.split("T")[0]
                          ).getMonth() + 1
                        );
                        setSearchFilter({ ...searchFilter, month: ele?.month });
                        dispatch(
                          getPayoutCountsNetworkAction({
                            ...searchFilter,
                            month: ele?.month,
                          })
                        );
                      }}
                    >
                      {formattedDate(ele?.appointmentClosedDate)}
                    </a>
                  </td>
                  <td style={{textAlign:"center"}}>{ele?.totalAppointments}</td>
                  <td style={{textAlign:"center"}}>{ele?.payoutAmount?.toLocaleString('en-IN')}</td>
                  <td style={{textAlign:"center"}}>{ele?.tds?.toLocaleString('en-IN')}</td>
                  <td style={{textAlign:"center"}}>{ele?.netAmount?.toLocaleString('en-IN')}</td>
                  <td >
                    <p
                    style={{margin:"auto"}}
                      className={`status-style ${
                        ele?.status === "Approved" ||ele?.status === "Paid"||
                        ele?.status === "Advance Paid"
                          ? "approved"
                          : ele?.status === "Rejected" ||
                            ele?.status ===
                              "Reject By Finance" ||
                            ele?.status === "Not Paid "
                          ? "rejected"
                          : ele?.status ===
                              "Pending At Finance" ||
                            ele?.status === "Pending at Network"
                          ? "pendingAtFinance"
                          : ele?.status ===
                            "Pending For Payment"
                          ? "pendingForpayment": ele?.status === "Refund" || ele?.status === "Partial Refund" || ele?.status === "Refund" || ele?.status === "Payment Lost" ? "refundStatus"
                          : "pending"
                      }`}
                    >
                      {" "}
                      {ele?.status}
                    </p>
                  </td>
                  <td style={{textAlign:"center"}}>
                    <button
                      className="btn search__btn action_export"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target= {searchFilter?.providerIds?.length>0 ? "":"#sendToQcModal"}
                      disabled={getNetworkMenuId()?.canEdit === false ? true 
                        :ele?.isPayoutStatus === false ? true 
                        : ( ele?.status !== "Pending At Network" &&
                      ele?.status !== "Partial QC") === true ? true :ele?.isInvoiceGenerated===false?true:false
                      }
                     onClick={()=>{
                      if(searchFilter?.providerIds?.length>0){
                        getSnackbarSuccess('error','Please remove Provider from search before proceeding to Send To QC',dispatch)
                      }
                      setProviderDetail([ele])
                     }}
                    >
                      Send to QC &nbsp;
                      <i class="fa-solid fa-caret-right"></i>
                    </button>
                  </td>
                  <td style={{textAlign:"center"}}>
                    <button
                      className="btn search__btn action_export"
                      type="button"
                      disabled={isLoadingExcel}
                      onClick={() => {
                        downloadFile(ele);
                      }}
                    >
                      <i className="fa-solid fa-file-csv"></i>&nbsp;
                      {isLoadingExcel ? "Exporting..." : "Export"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>}
          
        </table>
        {payoutReducer?.getPayoutDetailsList?.length === 0 && <p className="noRecordFound">No Record Found</p>}
      </div>
      
    </>
  );
};
